export default {
    delta: {
        url: 'compare/delta', //DELTA Series
        include: ['us', 'za', 'jp', 'cn', 'ca', 'uk', 'au', 'de', 'fr', 'it', 'es', 'cis', 'sa'],
    },
    river: {
        url: 'compare/river', //RIVER Series
        include: ['us', 'za', 'jp', 'cn', 'ca', 'uk', 'au', 'de', 'fr', 'it', 'es', 'cis', 'sa'],
    },
    solar: {
        url: '/compare/solar', //Solar Panels>Product Comparison
        include: ['us', 'za', 'jp', 'cn', 'ca', 'uk', 'au', 'de', 'fr', 'it', 'es', 'cis', 'sa'],
    },
};
